
import React from 'react';
import { Typography, Box, Grid, Card, CardContent } from '@mui/material';
import { styled } from '@mui/system';

const ImageCard = styled(Card)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(2),
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  '&:hover': {
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
  },
}));

const LocationImage = styled('img')({
  width: '100%',
  height: 'auto',
  borderRadius: '8px',
});

const LocationsSection = () => {
  const locations = [
    { id: 1, imageUrl: 'https://via.placeholder.com/600x400?text=Sede+1', title: 'Sede 1' },
    { id: 2, imageUrl: 'https://via.placeholder.com/600x400?text=Sede+2', title: 'Sede 2' },
    { id: 3, imageUrl: 'https://via.placeholder.com/600x400?text=Sede+3', title: 'Sede 3' },
  ];

  return (
    <Box mb={6} mt={10} className="locations-section">
      <Typography variant="h4" component="h3" gutterBottom>
        Nossas Sedes
      </Typography>
      <Typography variant="body1" component="p" gutterBottom>
        Estamos localizados em diferentes regiões para melhor atender nossos alunos. Confira nossas sedes e encontre a mais próxima de você.
      </Typography>
      <Grid container spacing={4} mt={4}>
        {locations.map(({ id, imageUrl, title }) => (
          <Grid item xs={12} sm={6} md={4} key={id}>
            <ImageCard>
              <LocationImage src={imageUrl} alt={title} />
              <CardContent>
                <Typography variant="h6" component="h4">
                  {title}
                </Typography>
              </CardContent>
            </ImageCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default LocationsSection;
